module.exports = __webpack_public_path__ + "35928ac37f33673b1b4462c322749dd3.png";